import React, { Component } from 'react';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import {
    WithStyles,
    createStyles,
    Button,
    Grid,
    Typography,
    Modal,
    Theme,
    Card,
    CardHeader,
    IconButton,
    CardContent,
    LinearProgress,
} from '@material-ui/core';
import { MyPATCollapse, MyPATDialog } from '../../common';
import PublishSharpIcon from '@material-ui/icons/PublishSharp';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/Close';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';

import axios from '../../../services/axios';
import CustomInfoIcon from '../../common/CustomInfoIcon';

const styles = (theme: Theme) => createStyles({
    borderX: {
        border: 'solid 1px;'
    },
    dashedBorder: {
        border: 'dashed 1px #000',
        padding: 8,
        borderRadius: 4
    },

    dashedBlock: {
        width: 276,
        margin: 12,
        height: 216
    },

    fontSize2X: {
        fontSize: 15
    },

    fontSize1X: {
        fontSize: 12
    },

    fontSize3X: {
        fontSize: 24,
        color: '#000',
        fontWeight: 'bold'
    },

    lineHeight2X: {
        lineHeight: 20
    },

    typographyStyle: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '15px',
        lineHeight: '20px',
        width: '100%'
    },

    lineHeightSm: {
        lineHeight: 16
    },

    modal: {
        display: 'flex',
        padding: 12,
        alignItems: 'center',
        justifyContent: 'center',
    },

    modalHeader: {
        height: 60,
        borderBottom: 'solid 1px #0004'
    },

    paper: {
        width: 680,
        marginTop: 100,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '20, 40, 30',
        textAlign: 'center'
    },

    colorGray: {
        color: '#9999'
    },

    headingFont: {
        fontSize: '1.25rem',
        fontWeight: 'bold',
        fontStyle: 'normal'
    },

    iconWidth: {
        width: 20
    },

    subHeadingFont: {
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 'bold'
    },

    margin1X: {
        margin: '6px'
    },

    root: {
        justifyContent: 'center'
    },

    border1x: {
        border: 'solid 0.5px #bbb',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.12)',
        borderRadius: '4px'
    },

    cardContent: {
        overflow: 'hidden'
    },

    blue: {
        border: 'solid 1px #1D7DEA',
        boxSizing: 'border-box',
        color: '#1D7DEA'
    },

    copyButton: {
        background: theme.palette.common.white
    },

    cardFooter: {
        padding: '6px 0px'
    },

    mathPreview: {
        height: 420,
        padding: 6,
        textAlign: "left",
        marginRight: 3,
        borderColor: "black",
        borderRadius: 0,
        width: "100%",
        position: "relative",
        '& > img': {
            width: "100%",
            position: "absolute",
            display: "block",
            left:0,
            top: "50%",
            transform: "translate(0%, -50%)",
        },
    },

    previewImageBlock: {
        position: 'fixed',
        display: 'block',
        top: 42,
    },

    previewThumbnailImage: {
        height: "70vh",
        padding:12,
        overflowY: "auto",
        minHeight:500,
        background: "#fff",
        maxWidth:960,
    },

    overlay: {
        top: 0,
        left: 0,
        width: "100%",
        right: 0,
        bottom: 0,
        cursor: "pointer",
        display: "block",
        zIndex: 999,
        position: "fixed",
        textAlign: "center",
        overflowX: "hidden",
        overflowY: "auto",
        backgroundColor: "rgba(0,0,0,0.5)",
    },

    zoomBlock: {
        height: "100%",
        cursor: "pointer",
        position: "absolute",
        background: "rgba(0,0,0,0.14)",
        width: "100%",
        top:0,
        left:0,
        '& img':{
            position: "absolute",
            top: "50%",
            left: '50%',
            transform: 'translate(-50%, -50%)',
        }
    },

    outPutCard: {
        margin: '17px 0px 0px 18px',
        // width: 412,
        height: 360
    },

    latexTextArea: {
        textAlign: 'justify',
        letterSpacing: 0,
        fontSize: 14,
        width: '100%',
        height: '100%'
    },

    latexCard: {
        padding: 12
    },

    latexDetail: {
        height: '150px'
    },

    latexFormulaCard: {
        minHeight: '106px',
        overflow: 'auto',
        padding: 10,
        height: 130,
        textAlign: 'justify',
        letterSpacing: 1
    },

    padding2x: {
        padding: 10
    },

    previewCloseIcon: {

    },

    marginLeft: {
        marginLeft: 18
    },

    previewHeader: {
        padding: '0px 0px 10px',
        borderBottom: 'solid 1px #9999',
        background: '#fff'
    }
});
interface MathPixDataInterface {
    confidence: number,
    confidenceRate: number,
    text: string,
    html: string
}
interface EasyMathsProps extends WithStyles<typeof styles> {
}
interface EasyMathsState {
    isUpload: boolean,
    uploadImage: string,
    isOpenUploadDialog: boolean,
    completed: number
    zoomIcon: boolean
    mathPixData: null | MathPixDataInterface,
    image: any,
    showZoomIcon: boolean
    isCopied: boolean,
}

class EasyMaths extends Component<EasyMathsProps, EasyMathsState>{
    upload: any = null
    textarea: any = null
    isOpenUploadDialog: boolean = false;
    inputForPaste: any = null
    wrapperRef: any = null
    constructor(props: EasyMathsProps) {
        super(props);
        this.state = {
            isUpload: false,
            uploadImage: "/assets/img/mylibrary/upload-image.png",
            isOpenUploadDialog: false,
            completed: 0,
            zoomIcon: false,
            mathPixData: null,
            image: null,
            showZoomIcon: false,
            isCopied: false
        }
        this.handleCLoseUpload = this.handleCLoseUpload.bind(this)
        this.handleUpload = this.handleUpload.bind(this)
        this.handleZoom = this.handleZoom.bind(this)
        this.zoomButton = this.zoomButton.bind(this)
        this.zoomOutButton = this.zoomOutButton.bind(this)
        // //@ts-ignore
        // this.upload = React.createRef();
        // //@ts-ignore
        // this.textarea = React.createRef();
        // //@ts-ignore
        // this.inputForPaste = React.createRef();
        // //@ts-ignore
    }

    // componentDidMount() {
    //     document.addEventListener('mousedown', this.handleClickOutside);
    // }

    // componentWillUnmount() {
    //     document.removeEventListener('mousedown', this.handleClickOutside);
    // }

    /**
     * Alert if clicked on outside of element
     */
    // handleClickOutside = (event: any) => {
    //     setTimeout(() => {
    //         if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
    //             this.setState({})
    //         }
    //     })
    // }

    handleUpload() {
        this.setState({
            isUpload: !this.state.isUpload,
            isOpenUploadDialog: true
        })
    }

    handleCLoseUpload() {
        this.setState({
            isOpenUploadDialog: false,
            mathPixData: null
        })
    }

    handleCopy = () => {
        try {
            this.setState({ isCopied: true })
            /* Select the text field */
            this.textarea.select();
            this.textarea.setSelectionRange(0, 99999); /*For mobile devices*/

            /* Copy the text inside the text field */
            document.execCommand("copy");
            return true;
        } catch (error) {
            console.log(error)
        }
    }

    handleZoom() {
        this.setState({
            zoomIcon: true
        })
    }

    zoomButton() {
        this.setState({
            showZoomIcon: true
        })
    }

    zoomOutButton() {
        this.setState({
            showZoomIcon: false
        })
    }

    readFile = (event: any) => {
        let file: any = null;
        //On paste
        if (event.clipboardData && event.clipboardData.files) {
            file = event.clipboardData.files[0]
        }
        //On upload 
        if (event.target.files) {
            file = event.target.files[0]
        }
        //On Drop 
        if (event.dataTransfer && event.dataTransfer.files) {
            file = event.dataTransfer.files[0]
        }
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        const reader = new FileReader();
        this.setState({ isUpload: true })
        reader.addEventListener("load", () => {
            // convert image file to base64 string
            const data = new FormData();
            data.append('image', file, file.fileName);
            axios
                .post(`mathlib/image`, data, config)
                .then((res) => {
                    this.setState({
                        isUpload: false,
                        image: reader.result,
                        isOpenUploadDialog: true,
                        mathPixData: {
                            //@ts-ignore
                            confidence: res.responseObject.confidence,
                            //@ts-ignore
                            confidenceRate: res.responseObject.confidence_rate,
                            //@ts-ignore
                            html: res.responseObject.html,
                            //@ts-ignore
                            text: res.responseObject.text
                        }
                    })
                }).catch((error) => {
                    console.log(error)
                })
        }, false);

        if (file) {
            reader.readAsDataURL(file);
        } else {
            this.setState({ isUpload: false })
        }
    }

    setFocusToInput = () => {
        // TODO added simple hack now fix it later 
        const d = document.getElementById('inputForPaste');
        if (d) {
            d.focus()
        }
        this.setState({})
    }


    handleImagePreviewCLose = () => {
        this.setState({
            zoomIcon: false
        })
    }

    handleDialogClose = () => {
        const {isOpenUploadDialog} = this.state;
        this.setState({
            isOpenUploadDialog:!isOpenUploadDialog
        })
    }

    render() {
        const { classes } = this.props;
        const { isUpload, isCopied, uploadImage, isOpenUploadDialog, completed } = this.state;

        return (
            <>
                {/* <MyPATCollapse 
                title={<>Easy Maths
                    <CustomInfoIcon
										infoDialogContentType="Goal Management"
										isInfoIcon={true}
										isRightArrow={false}
										isCenterArrow={true}
										knowMoreAbout={false}
										dialogTitle="Easy Maths"
										imageURL="/assets/svg/infoIcon/createQuestion/math.svg"
										dialogPara="This tool helps user to generate input with proper text and mathematical equations from image inserted inside Easy Maths feature. You can find more details in the Help section-> Editor Manual."
										details="Click to know more"
										toolTipDirection="top" />
                        </>}> */}

                    <Grid container justify="center">
                        <div ref={(ref) => { this.wrapperRef = ref; }}>
                            <Grid container justify="center"
                                onClick={
                                    (e) => {
                                        // TODO better to use ref but some error change it later 
                                        this.setFocusToInput()
                                    }
                                }
                                className={[classes.dashedBorder, classes.dashedBlock].join(' ')}
                                onDragOver={(event) => { event.preventDefault(); }}
                                onDrop={
                                    (event) => {
                                        event.preventDefault();
                                        this.readFile(event)
                                    }
                                }
                                style={!isUpload && document && document.activeElement && document.activeElement.id === 'inputForPaste' ? { opacity: 0.5 } : {}}
                            >
                                {isUpload ? <div className={classes.iconWidth}><CircularProgress /></div> : <img src={uploadImage} width="100" alt="easy" />}

                                <Typography className={[classes.typographyStyle, classes.colorGray, classes.margin1X, classes.fontSize2X, classes.lineHeight2X].join(' ')} component="div" variant="body1" align="center">
                                    {isUpload ? 'uploading' : 'You can drag an image or Paste (CTRL+V)'}
                                </Typography>
                                <input id="myInput" onChange={(event) => {
                                    this.readFile(event)
                                }} type="file" ref={(ref) => this.upload = ref} style={{ display: 'none' }} />
                                <input id="inputForPaste" type="text" ref={(ref) => this.inputForPaste = ref} onPaste={(event) => { this.readFile(event) }} style={{ opacity: 0, width: 0 }} />
                                <Button
                                    className={classes.margin1X}
                                    autoFocus
                                    variant="contained"
                                    color="primary"
                                    onClick={(e) => { this.upload.value = ''; this.upload.click() }}
                                >
                                    <PublishSharpIcon />
                                    Upload
                            </Button>
                            </Grid>
                        </div>
                        <Typography></Typography>
                        <Typography className={classes.fontSize1X} variant="body1" align="center" component="div">
                            Your mathematics will be automatically recognised and inserted
                    </Typography>
                    </Grid>
                {/* </MyPATCollapse> */}

                {/* <Modal
                    disablePortal
                    disableEnforceFocus
                    disableAutoFocus
                    aria-labelledby="server-modal-title"
                    aria-describedby="server-modal-description"
                    className={classes.modal}
                    title="Easy Maths"
                    open={isOpenUploadDialog}
                > */}
                <MyPATDialog
                    isApplyCustom
                    dialogHasActions={true}
                    isOverflowVisible={true}
                    disablePortal
                    disableEnforceFocus
                    disableAutoFocus
                    aria-labelledby="server-modal-title"
                    aria-describedby="server-modal-description"
                    className={classes.modal}
                    title="Easy Maths"
                    dialogOpen={isOpenUploadDialog}
                    onDialogClose={this.handleDialogClose}
                    otherDialogProps={{
                        fullWidth: true,
                        maxWidth: 'md'
                    }}
                    dialogHeading={
                        <>
                          <span 
                        //   className={classes.requestDialogTitle}
                          >
                          Easy Maths
                          </span>
                        </>
                      }
                >
                    <div 
                    // className={classes.paper}
                    >
                        {/* <Card className={classes.root}> */}
                            {/* <CardHeader className={classes.modalHeader}
                                action={
                                    <IconButton aria-label="settings" onClick={this.handleCLoseUpload}>
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                }
                                title="Easy Maths"
                            /> */}
                            {/* <CardContent className={classes.cardContent}> */}
                                <div>
                                    <Grid container>
                                        <Grid item xs={4} onMouseOver={this.zoomButton} onMouseUp={this.zoomButton}>
                                            <div className={[classes.border1x, classes.mathPreview].join(' ')}>
                                                <img src={this.state.image} alt="preview" />
                                                {this.state.showZoomIcon ? <Typography align="center" className={classes.zoomBlock} onClick={this.handleZoom}><img src="/assets/svg/resize-icon.svg" onClick={this.handleZoom} color="primary" /></Typography> : ' '}
                                            </div>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Typography className={[classes.subHeadingFont, classes.marginLeft].join(' ')} align="left" variant="body1">
                                                Output Results
                                            </Typography>
                                            <Grid container className={[classes.border1x, classes.outPutCard].join(' ')}>
                                                <Grid item className={classes.latexFormulaCard} xs={12}>
                                                    {this.state.mathPixData ? this.state.mathPixData.text : ''}
                                                </Grid>
                                                <Grid item xs={12} className={classes.latexCard}>
                                                    <div className={[classes.border1x, classes.latexDetail].join(' ')}>
                                                        <textarea className={[classes.latexTextArea, classes.padding2x].join(' ')} ref={(ref) => this.textarea = ref} defaultValue={this.state.mathPixData ? this.state.mathPixData.text : ''} readOnly />
                                                    </div>
                                                    <Grid container justify="space-between" spacing={8} className={classes.cardFooter}>
                                                        <Grid item>
                                                            <Typography align="left" variant="body2">
                                                                Confidence<br />
                                                                <LinearProgress color="primary" variant="determinate" value={((this.state.mathPixData && this.state.mathPixData.confidenceRate) ? this.state.mathPixData.confidenceRate : 0) * 100} />
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Button
                                                                className={[classes.copyButton, classes.blue].join(' ')}
                                                                variant="contained"
                                                                onClick={() => { if (this.handleCopy()) { this.handleCLoseUpload(); } }}
                                                            >
                                                                <img width="20" src="/assets/img/mylibrary/settingsMenu/copy-icon.png" />{" "}
                                                                Copy and close
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </div>
                                {this.state.zoomIcon ?
                                    <Grid container className={classes.overlay}>
                                        <Grid container>
                                            <Grid container justify="center" alignContent="center">
                                                <Grid item className={classes.previewImageBlock}>
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justify="space-between"
                                                        alignItems="flex-end"
                                                        className={classes.previewHeader}
                                                    >
                                                        <Grid item>

                                                        </Grid>
                                                        <Grid item>
                                                            <Typography className={classes.fontSize3X} variant="subtitle1" align="center">Preview</Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <IconButton aria-label="settings" className={classes.previewCloseIcon} onClick={this.handleImagePreviewCLose}>
                                                                <CloseIcon fontSize="large" />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item className={classes.previewThumbnailImage}>
                                                        <img className={classes.borderX} src={this.state.image} alt="preview" />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid> : ' '
                                }
                            {/* </CardContent> */}
                        {/* </Card> */}
                    </div>
                    </MyPATDialog>
                {/* </Modal> */}
            </>
        );
    }
}

// @ts-ignore
export default withStyles(styles)(EasyMaths);